import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import WrippleEstimateHorizontal from './WrippleEstimateHorizontal'
import {Dropdown} from 'antd';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import {useAuth} from "../../providers/AuthProvider";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

const ProjectPanel = ({project, showStatus, groupsAvailable,...props}) => {

    const {auth} = useAuth();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const translate = (key) => {
        return TB.trans(`projects.client_dashboard.panel_${key}`);
    }

    if (!auth) return null;

    const {
        name,
        shortlisted_candidates_count,
        interested_candidates_count,
        candidate_proposals_received_count,
        unseen_updated_candidate_proposals_count,
        messaged_candidates_count,
        unread_messages_count,
        requested_meetings_count,
        change_orders_count,
        unpublished_change_orders_count,
        approved_teams_count,
        upcoming_meetings_count,
        proposed_meetings_count
    } = project;

    let statusColor = project.statusColor(),
        statusClass = project.statusClass();


    let viewBtnTitle = project.panelViewButtonTitle();
    let shopSteps = project.shopSteps();

    let displayName = TB.truncate(name, {length: 49});

    const menu = (
        <ul className="bg-white min-w-[11rem] py-2 border border-gray-200 rounded font-primary">
            {/*{project.clientProjectGroup() && (*/}
            {/*    <li>*/}
            {/*        <p className="text-primary font-semibold py-2 px-6">{project.clientProjectGroup().name}</p>*/}
            {/*    </li>*/}
            {/*)}*/}

            <li>
                <button
                    type="button"
                    className="block w-full text-left py-2 px-6 font-normal hover:bg-gray-200 transition duration-150"
                    disabled={!project.canCancel() || !props.canEdit}
                    onClick={async () => {
                        await setIsMenuOpen(false)
                        await props.onToggleVisibility()
                        return project.addToCancel()
                    }}
                >
                    {!props.canEdit && <i className="fa fa-lock mr-1"/>} Cancel
                </button>
            </li>

            {auth.canManageClients() && project.canCancel() && (
                <li>
                    <button
                        type="button"
                        className="block w-full text-left py-2 px-6 font-normal text-danger hover:bg-gray-200 transition duration-150"
                        disabled={!project.canCancel()}
                        onClick={async () => {

                            await setIsMenuOpen(false)
                            props.onCloseProject()
                        }}>
                        Close Project
                    </button>
                </li>
            )}
            <li className="border-t border-gray-200 my-2" />


            <li>
                <button
                    type="button"
                    className="block w-full text-left py-2 px-6 font-normal hover:bg-gray-200 transition duration-150"
                    disabled={!project.canPutOnHold() || !props.canEdit}
                    onClick={async () => {
                        await setIsMenuOpen(false)
                        await props.onToggleVisibility()
                        return project.toggleOnHold()
                    }}
                >
                    {!props.canEdit && <i className="fa fa-lock mr-1"/>} {project.is_on_hold ? 'Make Active' : 'Put on hold'}
                </button>
            </li>

        </ul>
    )

    return (
        <div className='project-panel'>
            {groupsAvailable && (
                <div className="flex project-panel-group pl-4">
                    <p className="m-0">group</p>
                    <p className="m-0 pl-2">{project.client_project_group?.name || 'Public'}</p>
                </div>
            )}

            {showStatus && (
                <div className="panel-status">
                    <div style={{background: statusColor}}>
                        <h5>
                            {project.displayStatus().toUpperCase()}
                        </h5>
                    </div>
                </div>
            )}

            <div className="panel-info" style={{borderTopColor: statusColor}}>

                <div className="project-panel-header-btns">

                    {project.isBidding() && (
                        <Link
                            to={project.briefStep()}
                            className={TB.mapClass('edit-project-link', {
                                'disabled-edit-link': !props.canEdit
                            })}
                            onClick={e => {
                                if (!props.canEdit) {
                                    e.preventDefault();
                                    TB.showPermissionError();
                                }
                            }}
                        >
                            <span>edit</span>

                            {!props.canEdit ? (
                                <i className="fa fa-lock ml-1"/>
                            ) : (
                                <i className="fa fa-edit ml-1"/>
                            )}
                        </Link>
                    )}

                    {(project.canCancel() || project.canPutOnHold()) && (
                        <Dropdown open={isMenuOpen} onOpenChange={open => setIsMenuOpen(open)} overlay={menu} trigger={['click']} placement="bottomRight">
                            <a onClick={e => setIsMenuOpen(true)} className="flex items-center pl-3 pr-2 font-primary">
                                <i className="fas fa-ellipsis-h text-2xl"/>
                            </a>
                        </Dropdown>
                    )}
                </div>

                <div className="py-3 px-4">

                    <div className="pt-1 pb-2">

                        <ResponsiveEllipsis
                            text={project.isBYO()
                                ? "Hire by Open Positions"
                                : "Find Teams by Project Type"}
                            className="project-panel-label"
                            maxLine='1'
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />

                        <p className="project-panel-title">
                            <span className="project-title">
                                {displayName}
                            </span>

                            <small>
                                {project?.service?.name || ''}
                            </small>
                        </p>

                        {project.isBidding() && shopSteps.map(step => step.render())}

                        {!project.isBidding() && !project.isCancelled() && (
                            <Link to={project.detailLink()} className={`project-panel-steps-btn btn btn-${statusClass} btn-block`}>
                                {viewBtnTitle}
                            </Link>
                        )}

                    </div>
                </div>


                <div className="px-4 project-panels-progress-info">
                    <div className="project-panels-progress-section">
                        <h4>
                            Created: <b>{TB.moment(project.created_at).fromNow()}</b>
                        </h4>
                        <h4>
                            Last Activity: <b>{TB.moment(project.updated_at).fromNow()}</b>
                        </h4>
                    </div>
                    {project.isNew() ? (
                        <div className="project-panels-progress-section">

                            <div className="project-panel-section-details">
                                <p className="text-gray">
                                    {project.panelNewTeamsSectionText().body}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="project-panels-progress-section">
                            <h5 className="mb-1">
                                Status:
                                &nbsp;
                                <i className={TB.mapClass("fas", {
                                    'text-danger fa-times-circle': project.is_on_hold,
                                    'text-success fa-check-circle': !project.is_on_hold
                                })}/>
                                &nbsp;
                                {project.is_on_hold ? (
                                    <span>
                                        <b>On Hold</b>
                                    </span>
                                ) : (
                                    <span>
                                        <b>Search Active</b>
                                    </span>
                                )}
                            </h5>

                            {(project.isBYO() && (project.isBidding())) && (
                                <React.Fragment>
                                    {/* <h5>
                                            Roles Filled: <b>
                                                {project.filledPositionCount()}/{project.sortedPositions()?.length || 0}
                                            </b>
                                        </h5> */}
                                    <h5>
                                        Talent Proposals: <b>{candidate_proposals_received_count || 0}</b>
                                        {!!unseen_updated_candidate_proposals_count && <span className="ml-1 py-px px-1.5 bg-danger rounded-xl text-white text-[10px]">{unseen_updated_candidate_proposals_count}&nbsp; Updated</span>}
                                    </h5>
                                    <h5>
                                        Candidates Messaged: <b>{messaged_candidates_count}</b>
                                        {!!unread_messages_count && <span className="ml-1 py-px px-1.5 bg-danger rounded-xl text-white text-[10px]">{unread_messages_count}&nbsp; Unread</span>}

                                    </h5>
                                    <h5>
                                        Interview Requests: <b>{upcoming_meetings_count + proposed_meetings_count}</b>
                                        {!!upcoming_meetings_count && <span className="ml-1 py-px px-1.5 bg-danger rounded-xl text-white text-[10px]">{upcoming_meetings_count}&nbsp; Upcoming</span>}
                                    </h5>
                                </React.Fragment>
                            )}
                            {project.isActive() && (
                                <React.Fragment>
                                    <h5>
                                        Start Date <b>{TB.moment(project.anticipatedStart()).format('ll')}</b>
                                    </h5>
                                    <h5>
                                        End Date <b>{TB.moment(project.anticipatedEnd()).format('ll')}</b>

                                    </h5>
                                    {project.isBYO() && (
                                        <React.Fragment>
                                            <h5>
                                                Positions: <b>{project.positions?.length}</b>
                                            </h5>
                                            <h5>
                                                Change Orders: <b>{change_orders_count || 0}</b>
                                                {!!unpublished_change_orders_count && <span className="ml-1 py-px px-1.5 bg-danger rounded-xl text-white text-[10px]">{unpublished_change_orders_count}&nbsp; Pending</span>}
                                            </h5>
                                        </React.Fragment>
                                    )}

                                </React.Fragment>
                            )}

                            {project.isService() && (
                                <React.Fragment>
                                    <h5>
                                        Team Matches: <b>{approved_teams_count || 0}</b>
                                    </h5>
                                    <h5>
                                        Proposals Requested: <b>{shortlisted_candidates_count}</b>
                                    </h5>
                                    <h5>
                                        Proposals Received: <b>{candidate_proposals_received_count}</b>
                                    </h5>

                                </React.Fragment>
                            )}


                        </div>
                    )}

                </div>

                <WrippleEstimateHorizontal
                    project={project}
                    editable={false}
                    trademark={project.isFixedFee()}/>
            </div>
        </div>
    );
}
export default ProjectPanel;